import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cache object URLs across renders to avoid repeated fetches.
// Module-level so it survives component unmounts.
const blobCache = new Map();

export const useAuthenticatedMedia = (mediaId) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!mediaId) {
      setBlobUrl(null);
      return undefined;
    }

    const cached = blobCache.get(mediaId);
    if (cached) {
      setBlobUrl(cached);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await axios.get(`${API_URL}/api/media/${mediaId}`, {
          withCredentials: true,
          responseType: 'blob',
        });
        if (cancelled) return;
        const url = URL.createObjectURL(response.data);
        blobCache.set(mediaId, url);
        setBlobUrl(url);
      } catch (err) {
        if (!cancelled) setError(err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [mediaId]);

  return { blobUrl, error };
};
